import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from '../shared/styles';

class Feature extends Component {
  constructor(props) {
    super(props);

    this.inputRef = null;
  }

  componentDidMount() {
    const { willFocus } = this.props;
    if (willFocus) {
      this.inputRef.focus();
    }
  }

  render() {
    const { prefix, value, placeholder, onInputChange, onInputKeyUp, onDelete } = this.props;

    return (
      <div style={styles.multipleInputWrapper}>
        <div style={styles.multipleInputLeft}>{prefix}</div>
        <input
          ref={ref => (this.inputRef = ref)}
          type="text"
          style={{ ...styles.multipleInputCenter, margin: 0 }}
          placeholder={placeholder}
          onChange={onInputChange}
          onKeyUp={onInputKeyUp}
          value={value}
        />
        <span style={{ ...styles.multipleInputRight, cursor: 'pointer' }} onClick={onDelete}>
          <i className="fa fa-times " aria-hidden="true" />
        </span>
      </div>
    );
  }
}

Feature.propTypes = {
  prefix: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onInputChange: PropTypes.func,
  onInputKeyUp: PropTypes.func,
  onDelete: PropTypes.func,
  willFocus: PropTypes.bool,
};

Feature.defaultProps = {
  prefix: '',
  value: '',
  placeholder: '',
  onInputChange: () => {},
  onInputKeyUp: () => {},
  onDelete: () => {},
  willFocus: false,
};

export default Feature;
